import React, { useState, useRef, useEffect } from 'react';
import { useSortContext } from '../context/SortContext';
import SortOptionsPanel from './SortOptionsPanel';
import styles from './SortButton.module.css';

const SortButton = () => {
  const { hasCustomSortSettings } = useSortContext();

  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className={styles.sortButtonContainer} ref={dropdownRef}>
      <button
        className={`${styles.sortButton} ${hasCustomSortSettings ? styles.active : ''}`}
        onClick={toggleDropdown}
        title="Sort and Group Options"
      >
        <span className={styles.buttonText}>Sort</span>
        <span className={`${styles.arrow} ${isOpen ? styles.up : styles.down}`}>▼</span>
      </button>

      {isOpen && (
        <div className={styles.dropdown}>
          <SortOptionsPanel />
        </div>
      )}
    </div>
  );
};

export default SortButton;
